import { NavigationDropdown } from "@components/general/NavigationDropdown/NavigationDropdown";
import { DefaultNavigationDropdownToggle } from "./DefaultNavigationDropdownToggle";
import { DefaultNavigationDropdownBody } from "./DefaultNavigationDropdownBody";

export const DefaultNavigationDropdown = () => (
    <NavigationDropdown toggle={DefaultNavigationDropdownToggle}>
        <DefaultNavigationDropdownBody />
    </NavigationDropdown>
);
